// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"SuccesModal_dialogContent__vO4IL","mainDiv":"SuccesModal_mainDiv__3NDpo","thumbs":"SuccesModal_thumbs__1mNGS","txt":"SuccesModal_txt__2fSCJ"};